import React, { PureComponent } from "react";

import Album from "Common/Album";

import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "i18n";

import styles from "./SelectAlbum.local.scss";

export default class SelectAlbumComponent extends PureComponent {
  static defaultProps = {
    showAdd: true
  };

  static propTypes = {
    albums: PropTypes.array,
    fetchingState: PropTypes.string
  };

  renderAlbums() {
    const { albums, fetchingState, showAdd, onClikAddNewAlbum } = this.props;
    if (fetchingState === "fetching") {
      const fetchingClasses = classnames(styles.fetching, styles.list);
      return (
        <div className={fetchingClasses}>
          <ul>
            <li className={styles.item} />
            {[...Array(4)].map((v, i) => (
              <li className={styles.item} key={`folder-${i}`} />
            ))}
          </ul>
        </div>
      );
    }
    const addFolderClass = classnames(styles.item, styles.addFolder);
    return (
      <div className={styles.list}>
        <ul>
          {showAdd && (
            <li className={addFolderClass} onClick={onClikAddNewAlbum}>
              <i className="plus plus--blue" />
              {_("Créer un Album")}
            </li>
          )}
          {albums.map(album => {
            return (
              <li key={album.id} className={styles.item}>
                <Album key={album.id} album={album} saveEvent={true} />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  renderSelectedMedia() {
    const checks = document.getElementsByClassName("check");

    //TODO obtenir selectedMedia depuis le store
    let mediasBlocs = [];
    for (let el of checks) {
      if (!el.classList.contains("disabled")) {
        const sibling = el.previousSibling;
        const path = $(sibling)
          .find("img:last")
          .attr("src");
        mediasBlocs.push(
          <div className="cell small-6">
            <div
              style={{
                backgroundImage: `url('${path}')`
              }}
            />
            {$(sibling)
              .find("h4")
              .text()}
          </div>
        );
      }
    }

    const classes = classnames(styles.selectedMedia, "grid-x");
    return (
      <div id="selectedContainer" className={styles.selectedContainer}>
        <div className={classes}>{mediasBlocs}</div>
      </div>
    );
  }

  render() {
    const {
      onClickClose,
      onClikAddNewAlbum,
      displaySelectedMedia,
      showAdd
    } = this.props;
    const closeClasses = classnames("close", "close--white", styles.close);

    return (
      <div className={styles.albums}>
        <div className={styles.albums__header}>
          <div className={styles.groupTitles}>
            <h2>{_("ajouter votre media à un album")}</h2>
            <h3>
              {_("Séléctionnez ou créer un ALBUM pour ajouter vos medias")}
            </h3>
          </div>
          <div className={closeClasses} onClick={onClickClose} />
        </div>
        {this.renderAlbums()}
        {/* {showAdd && (
          <div className={styles.plus}>
            <i className="icon-close" onClick={onClikAddNewAlbum} />
          </div>
        )} */}
        {displaySelectedMedia ? this.renderSelectedMedia() : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/SelectAlbum/SelectAlbumComponent.js